import axios from 'axios';

const { REACT_APP_STOCK_DOMAIN } = process.env;

const load = stock_code => {
	return axios.get(
		`${REACT_APP_STOCK_DOMAIN}/data_fetch/api/CustomFinancialHeatmapPnL/${stock_code}`,
		{
			headers: {
				Accept: 'application/json',
			},
		}
	);
};

export default { load };
